import React from 'react';

import ArrowBackIcon from '@material-ui/icons/KeyboardBackspace';

const ArrowForwardIcon = (props) => <ArrowBackIcon {...props} style={{ transform: 'rotate(-180deg)' }} />;

export default ArrowForwardIcon;
